import { bootstrap } from '@zg-rentals/rp-bootstrap-browser';

const rpBootstrap = bootstrap({
  appName: 'rental-growth-web',
  buildNumber: Number(__BUILD_NUMBER__ ?? -1),
  loggerOptions: {
    name: 'rental-manager-web',
    logPath: `/rental-manager/growth/log`,
  },
  monitorOptions: {
    proxyPath: '/rental-manager/growth/pontoon-proxy',
  },
});

// @ts-ignore
window.getLogger = rpBootstrap.getLogger.bind(rpBootstrap);

export { rpBootstrap };
